import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from "react-router-dom";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { SubmitButton } from "@/components/ui/button";
import {
  OrganizationPayloadSchema,
  organizationPayloadSchema,
  useOrganizationCreate,
} from "@/api/organization";
import { OrganizationFormFields } from "./OrganizationFormFields";
import { FormContainer } from "@/components/form/form-container";
import { Anchor } from "@/components/ui/anchor";
import { FormInfo } from "@/components/ui/form-info";

export function OrganizationCreateForm() {
  const form = useForm<OrganizationPayloadSchema>({
    resolver: zodResolver(organizationPayloadSchema),
  });
  const { mutate, isPending } = useOrganizationCreate();
  const navigate = useNavigate();

  function handleSubmit(values: OrganizationPayloadSchema) {
    mutate(
      { data: values },
      {
        onSuccess: () => {
          swalSuccess
            .fire({
              text: "Organization has been created",
            })
            .then(() => navigate("/master-data/organization"));
        },
        onError: (error) => {
          swalError.fire({
            text: error.message,
          });
        },
      },
    );
  }

  return (
    <FormContainer form={form} onSubmit={handleSubmit}>
      <FormInfo
        label="Terms"
        values={["The maximum data inputted in each field is 255 characters"]}
      />
      <OrganizationFormFields />
      <div className="ml-auto flex gap-x-2">
        <Anchor href="/master-data/organization" mood="axiata-blue-outline">
          Cancel
        </Anchor>
        <SubmitButton loading={isPending} />
      </div>
    </FormContainer>
  );
}
